module.exports = __webpack_public_path__ + "img/download.f7d264bc.svg";